/**
 * `/$tenantSlug` — tenant-scoped parent route. Wraps every module route in
 * the shell Layout, gated behind <AuthGuard> so the internal chrome never
 * renders for an unauthenticated visitor.
 */

import { createFileRoute } from "@tanstack/react-router";
import type { ReactElement } from "react";

import { AuthGuard } from "../shell/AuthGuard";
import { Layout } from "../shell/Layout";

export const Route = createFileRoute("/$tenantSlug")({
  component: GatedLayout,
});

function GatedLayout(): ReactElement {
  return (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  );
}
